import URLSearchParams from 'url-search-params';

const urlParams = new URLSearchParams(window.location.search);

const url = urlParams.get('url');
const src = urlParams.get('src');
let label = urlParams.get('label');
let count = urlParams.get('count');
let align = urlParams.get('align');

label = label === 'save' ? label : 'pocket';
count = ['horizontal', 'vertical'].includes(count) ? count : 'none';
align = ['center', 'left', 'right'].includes(align) ? align : count === 'horizontal' ? 'left' : 'center';

export default {
  url,
  src,
  label,
  count,
  align,
  pocketUrl: window.__STATE__.pocketUrl,
};
